import { motion } from "framer-motion";
import { Star, DollarSign, Heart } from "lucide-react";

export const RestaurantMiniCard = ({ restaurant, onClick, isFavorite }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="glass rounded-xl overflow-hidden cursor-pointer"
      data-testid={`mini-card-${restaurant.id}`}
    >
      {/* Main Photo */}
      <div className="aspect-video relative">
        <img
          src={restaurant.main_photo || "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400"}
          alt={restaurant.name}
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Info */}
      <div className="p-3">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-semibold text-sm truncate flex-1">{restaurant.name}</h3>
          {isFavorite && (
            <Heart size={14} className="fill-red-500 text-red-500 ml-2 flex-shrink-0" />
          )}
        </div>
        <p className="text-xs text-amber-500 mb-1">{restaurant.cuisine_type}</p>
        <p className="text-xs text-zinc-400 truncate mb-2">
          {restaurant.address}, {restaurant.city}{restaurant.province ? ` (${restaurant.province})` : ""}{restaurant.postal_code ? `, ${restaurant.postal_code}` : ""}, {restaurant.country}
        </p>
        
        {/* Opinion Rating */}
        <div className="flex items-center gap-1 mb-1">
          {[1, 2, 3, 4, 5].map((i) => (
            <Star key={i} size={10} className={i <= Math.round(restaurant.avg_rating || 0) ? "fill-amber-500 text-amber-500" : "text-zinc-600"} />
          ))}
          <span className="text-xs text-zinc-300 ml-1">{restaurant.avg_rating?.toFixed(1) || "0"}</span>
        </div>
        
        {/* Price Rating */}
        <div className="flex items-center">
          {[1, 2, 3, 4, 5].map((i) => (
            <DollarSign key={i} size={10} className={i <= Math.round(restaurant.avg_price || 0) ? "text-emerald-500" : "text-zinc-700"} />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default RestaurantMiniCard;
